const { hostname } = window.location;

function setAuthority(authority: string | undefined = undefined) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  this.authority = authority || 'https://dev-login.revers.io';

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return this;
}

const AuthConfiguration = {
  authority: 'https://dev-login.revers.io',
  setAuthority,
  clientId: 'dev-field-service-app.revers.io',
  scope: 'openid email api',
};

if (
  hostname !== 'localhost' &&
  !hostname.includes('.dev-field-service-app.pages.dev')
) {
  AuthConfiguration.clientId = window.location.hostname;
}

AuthConfiguration.setAuthority();

export default AuthConfiguration;
